import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "fill"]
const _hoisted_2 = { "clip-path": "url(#clip0_11969_54488)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_54488" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "10",
      height: "10",
      fill: "white",
      transform: "translate(10) rotate(90)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'swapIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#878787",
  },
  width: {
    type: Number as PropType<number>,
    default: 10,
  },
  height: {
    type: Number as PropType<number>,
    default: 10,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: __props.color,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M5.73705 2.49988C5.73727 2.57146 5.75593 2.64177 5.79122 2.70404C5.8274 2.76841 5.88003 2.822 5.94372 2.85934C6.00741 2.89667 6.07989 2.91642 6.15372 2.91654L6.66622 2.91654C6.69385 2.91654 6.72034 2.92752 6.73988 2.94705C6.75941 2.96659 6.77038 2.99308 6.77038 3.02071L6.77038 7.23321C6.77038 7.39897 6.83623 7.55794 6.95344 7.67515C7.07065 7.79236 7.22962 7.85821 7.39538 7.85821C7.56115 7.85821 7.72012 7.79236 7.83733 7.67515C7.95454 7.55794 8.02038 7.39897 8.02038 7.23321L8.02038 3.02071C8.02034 3.0063 8.02328 2.99204 8.02903 2.97883C8.03478 2.96561 8.04321 2.95373 8.05378 2.94394C8.06435 2.93415 8.07684 2.92666 8.09046 2.92195C8.10407 2.91723 8.11852 2.91539 8.13288 2.91654L8.65372 2.91654C8.72726 2.91653 8.79949 2.89705 8.86307 2.86009C8.92665 2.82312 8.97931 2.76999 9.01571 2.70609C9.0521 2.64218 9.07094 2.56978 9.0703 2.49624C9.06965 2.4227 9.04956 2.35064 9.01205 2.28738L7.76205 0.204044C7.72516 0.141868 7.67272 0.0903615 7.6099 0.0545866C7.54707 0.0188118 7.47602 -6.96889e-08 7.40372 -7.28491e-08C7.33142 -7.60094e-08 7.26037 0.0188118 7.19754 0.0545866C7.13471 0.0903614 7.08228 0.141868 7.04539 0.204044L5.79539 2.28738C5.75722 2.35169 5.73707 2.42509 5.73705 2.49988Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M2.9515 9.79479L4.2015 7.71146C4.23901 7.6482 4.25911 7.57614 4.25975 7.5026C4.26039 7.42906 4.24156 7.35666 4.20516 7.29275C4.16876 7.22885 4.1161 7.17571 4.05252 7.13875C3.98894 7.10178 3.91671 7.08231 3.84317 7.08229L3.33067 7.08229C3.30304 7.08229 3.27655 7.07132 3.25701 7.05178C3.23748 7.03225 3.2265 7.00575 3.2265 6.97813L3.2265 2.76563C3.2265 2.59986 3.16066 2.44089 3.04345 2.32368C2.92624 2.20647 2.76727 2.14062 2.6015 2.14062C2.43574 2.14062 2.27677 2.20647 2.15956 2.32368C2.04235 2.44089 1.9765 2.59986 1.9765 2.76562L1.9765 6.97813C1.9765 7.00575 1.96553 7.03225 1.94599 7.05178C1.92646 7.07132 1.89996 7.08229 1.87234 7.08229L1.3515 7.08229C1.27767 7.08242 1.2052 7.10216 1.14151 7.1395C1.07781 7.17684 1.02518 7.23043 0.989004 7.29479C0.953712 7.35707 0.935057 7.42738 0.934838 7.49896C0.93486 7.57374 0.955009 7.64714 0.993171 7.71146L2.24317 9.79479C2.28006 9.85697 2.3325 9.90848 2.39533 9.94425C2.45815 9.98003 2.52921 9.99884 2.6015 9.99884C2.6738 9.99884 2.74486 9.98003 2.80768 9.94425C2.87051 9.90848 2.92294 9.85697 2.95984 9.79479L2.9515 9.79479Z",
        fill: __props.color
      }, null, 8, _hoisted_4)
    ]),
    _hoisted_5
  ], 8, _hoisted_1))
}
}

})